
const state = {
  userInfo: {},
  headerTitle: {
    img: '',  // header的图片 1:微商城  2:
    pageType: '',  // header的页面类型
    shopName: '',  // 当前页面的店铺name
    shopType: ''  // 当前页面的店铺类型
  }
}


export default state
